<dialog class="modal" #dialog>
  <div class="modal-box">
    <h3 class="text-lg font-bold">{{ title }}</h3>
    <p class="py-4" [innerHTML]="content | safe: 'html'"></p>
    @if (action) {
      <div class="modal-action">
        <form method="dialog">
          <!-- if there is a button in form, it will close the modal -->
          <button
            class="btn btn-primary btn-sm mr-2"
            (click)="confirm.emit(true)">
            Đồng ý
          </button>
          <button class="btn btn-sm" (click)="confirm.emit(false)">
            Không
          </button>
        </form>
      </div>
    }
  </div>
</dialog>
